import { useState } from "react"
import { Space, Flex } from "antd"
import { EyeOutlined } from "@ant-design/icons"
import { Title } from "ui/Typography"
import PropTypes from "prop-types"
import CustomQuestions from "pagesV2/pro/Embedded/BookingConfirmation/modal/CustomQuestions"
import styles from "./index.module.css"

const NotesAndQuestionnaire = ({ booking }) => {
  const { note, booking_questionnaire_id, booking_questionnaire, uuid } = booking || {}
  const [showQuestionnaire, setShowQuestionnaire] = useState(false)

  const questionnaireId = booking_questionnaire?.id || booking_questionnaire_id
  const hasQuestionnaire = !!(booking_questionnaire_id || booking_questionnaire?.id)
  const status = booking_questionnaire?.status
  const isSubmitted = status === "submitted"

  if (!note && !hasQuestionnaire) return null

  return (
    <Space direction="vertical" className={`${styles.container} w-full p-xl`}>
      <Title level={4} className="mb-l">
        Questionnaire
      </Title>

      {note && (
        <div className={styles.notesSection}>
          <div className={styles.label}>Notes</div>
          <div className={styles.noteText}>{note}</div>
        </div>
      )}

      {hasQuestionnaire && (
        <Flex justify="space-between" align="center" className={`${note ? styles.questionnaireSectionWithBorder : ""}`}>
          <Flex
            align="center"
            gap={6}
            className={isSubmitted ? styles.questionnaireLink : undefined}
            onClick={isSubmitted ? () => setShowQuestionnaire(true) : undefined}
          >
            {isSubmitted && <EyeOutlined />}
            <span>Questionnaire</span>
          </Flex>
          <span className={isSubmitted ? styles.statusSubmitted : styles.statusPending}>
            {isSubmitted ? "Submitted" : "Pending"}
          </span>
        </Flex>
      )}

      {showQuestionnaire && isSubmitted && (
        <CustomQuestions
          uuid={uuid}
          bookingQuestionnaireId={questionnaireId}
          questionnaireEditable={false}
          hideEditWarning={true}
          visible={showQuestionnaire}
          onClose={() => setShowQuestionnaire(false)}
        />
      )}
    </Space>
  )
}

NotesAndQuestionnaire.propTypes = {
  booking: PropTypes.object
}

export default NotesAndQuestionnaire
